// TOUR-16 — Admin org settings + locations (self-service setup; not member invite).

import type { FireflyTourArtifact } from "../tourTypes";

export const ADMIN_ORG_TOUR_ID = "tour-admin-org";

export const ADMIN_ORG_TOUR: FireflyTourArtifact = {
  id: ADMIN_ORG_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "org settings tour",
    "configure my organization",
    "add a location",
    "organization settings tour",
    "how do i configure my organization",
    "walk me through org settings",
    "show me org settings",
    "org locations tour",
  ],
  bucketRelevance: ["admin"],
  requiredRoles: ["admin", "owner", "org_admin", "org_owner"],
  steps: [
    {
      id: "nav-admin",
      target: { mode: "admin", anchorId: "mode-nav-admin", scrollIntoView: true },
      deferModeNavigation: true,
      skipWhenCurrentMode: "admin",
      copy: {
        title: "Open Admin",
        body: "Org branding, locations, and CRM connections live under Admin. Tap Admin in the sidebar (or bottom bar on mobile).",
      },
      waitForClick: true,
    },
    {
      id: "org-settings",
      target: { mode: "admin", anchorId: "admin-org-settings", scrollIntoView: true },
      copy: {
        title: "Org Administration",
        body: "Open Org Administration, then expand Org Settings to edit brand name, colors, logo, and product types for this workspace.",
      },
      waitForClick: true,
    },
    {
      id: "locations",
      target: { mode: "admin", anchorId: "admin-locations", scrollIntoView: true },
      copy: {
        title: "Locations",
        body: "Expand Locations to manage retail lots, plants, and offices. Use + New location when you need to add a lot — member invites are under App User Admin, not here.",
      },
      waitForClick: true,
    },
    {
      id: "org-profile-save",
      target: { mode: "admin", anchorId: "admin-org-profile-save", scrollIntoView: true },
      copy: {
        title: "Save settings",
        body: "Back in Org Settings, Save settings persists branding and profile fields for the org. You perform the save yourself — the tour will not write changes.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "admin", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Invites and role approvals are a separate Admin tour under App User Admin. Ask Firefly anytime for member invite or other mode walkthroughs.",
      },
      advanceOn: "next_button",
    },
  ],
};
